<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import appConfig from "@/app.config";
import copyrightConfig from "@/utils/config/changeCopyright.js";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      const appid = copyrightConfig.AppID;
      const appName = appConfig.appNames[appid] || "接龙加加";
      return title ? `${title} | ${appName} - 免费微信接龙报名小程序平台` : `${appName} - 免费微信接龙报名小程序平台`;
    }
  }
};
</script>